// @flow
import reducer from './duck/reducer';
import * as actions from './duck/actions';
import * as api from './duck/api';
import * as model from './duck/model';
import * as selectors from './duck/selectors';

export { actions, api, model, selectors };
export default reducer;
